import ApplicationNameRemapping from '../lib/ApplicationNameRemapping.json';

export const remapApplicationName = (applicationName: string): string => {
  const remappedName =
    ApplicationNameRemapping[
      applicationName as keyof typeof ApplicationNameRemapping
    ] || applicationName;
  return remappedName;
};
